import { render, staticRenderFns } from "./IconTranslateOutline.vue?vue&type=template&id=5fe84b35"
import script from "./IconTranslateOutline.vue?vue&type=script&lang=js"
export * from "./IconTranslateOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports